import PropTypes from "prop-types";
import { Card } from "../ui/card";

function OverlayNewsCard({ image, title, source, link = "#" }) {
  return (
    <a onClick={()=>window.open(link,"_blank")} className="block hover:opacity-95 transition-opacity">
      <Card className="overflow-hidden border-0 shadow-md w-[280px] h-[280px] flex-shrink-0 rounded-2xl relative">
        <div className="relative w-full h-full">
          <img
            src={image || "/placeholder.svg"}
            alt={title}
            className="object-cover w-full h-full"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
            <p className="text-yellow-400 text-sm mb-1">{source}</p>
            <h3 className="text-lg font-semibold line-clamp-2 leading-tight">
              {title}
            </h3>
          </div>
        </div>
      </Card>
    </a>
  );
}

OverlayNewsCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  link: PropTypes.string
};

export default OverlayNewsCard;
